/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from "react";
import { AppTranslation } from "../../../../../i18n/useAppTranslation";
import EditorWithPreview from "../../../../Common/EditorWithPreview";

export function ModalRescheduleNotification({
  onClose,
  handleInputChange,
  patientName,
  notificationType,
  notificationBody,
  handleEditorChange,
  sendNotification,
}) {
  return (
    <div className="blackOverlay">
      <div className="vert-middle">
        <div className="loyaltyMembership start-program-main">
          <div className="newPopupTitle">
            <div className="popup-name">Send Notification</div>
            <a className="popupClose" onClick={onClose}>
              <img src="/images/close.png" alt="" />
            </a>
          </div>
          <div className="newPopupContent">
            <div className="juvly-subtitle m-b-10">
              Your appointment has been rescheduled successfully!
            </div>
            <div className="row">
              <div className="col-xs-12">
                <div className="simpleField">
                  <div className="simpleLabel">
                    {patientName} will be notified via:
                  </div>
                  <select
                    className="simpleSelect"
                    name="notification_type"
                    onChange={handleInputChange}
                    value={notificationType}
                  >
                    <option value="email">Email</option>
                    <option value="sms">SMS</option>
                    <option value="emailAndSms">Email and SMS Both</option>
                  </select>
                </div>
              </div>
            </div>
            <p className="p-text">
              Notification Message (optional)
              <br />
              <AppTranslation.Appointments path="appointmentTopNotification" />
            </p>
            <div className={"newInputFileldOuter m-b-40"}>
              <EditorWithPreview
                name={"notification_body"}
                placeholder={"Email Body"}
                value={notificationBody}
                className="editor_textarea editor-preview"
                handleEditorChange={handleEditorChange}
              />
            </div>
            <div className="simpleField no-display">
              <textarea
                className="simpleTextarea h-130 scroll-y m-b-10"
                name="notification_body"
                onChange={handleInputChange}
                value={notificationBody}
              >
                {notificationBody}
              </textarea>
            </div>
          </div>
          <div>
            <a onClick={onClose} className="new-red-btn pull-left no-width">
              {"Don't Send Notification"}
            </a>
            <a className="new-blue-btn pull-right" onClick={sendNotification}>
              Send Notification
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
